module.exports = __webpack_public_path__ + "img/logo-merrymama_x_dfc.bc7fe2e9.jpg";